/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export interface ApprovalChatRoomUserInfo {
  /** 병원 ID */
  hospitalID: string;
  /** 채팅방 관련 동작을 승인 요청한 사용자 ID */
  requestorID: UserNameAndType;
  /** 채팅방 관련 동작을 승인 요청한 채팅방 ID */
  chatRoomID: string;
  /** 채팅방 관련 동작을 승인 요청한 채팅방의 이름(환자 채팅방의 경우 환자 이름) */
  chatRoomName: string;
  /** 채팅방 관련 동작 승인 상태 */
  status: string;
  /** 승인 요청 타입 */
  type: string;
  /** 생성일시 */
  createdAt: string;
  /** 수정일시 */
  updatedAt: string;
  /** 승인자 ID */
  responderID?: UserNameAndType;
  /** 승인 또는 미승인일시 */
  respondedAt?: string;
}

export interface UserNameAndType {
  /** 유저 ID */
  _id: string;
  /** 이름 */
  name: string;
  /** 유저의 실제 이름 */
  realName: string;
  /** 유저 타입 */
  type: string;
  /** 유저의 직무 또는 직책 */
  jobType: string;
}

export interface ApprovalMobilePhoneChangeCountryCode {
  /** 휴대폰번호 변경 요청 ID */
  _id: string;
  /** 병원 ID */
  hospitalID: string;
  /** 휴대폰번호 변경 요청한 모바일 앱 유저의 userID */
  userID: string;
  /** 휴대폰번호 변경 요청한 모바일 앱 유저의 서비스 ID */
  hserviceID: string;
  /** 변경 전 휴대폰번호 */
  oldPhone: string;
  /** 변경 전 휴대폰번호 국가 코드 */
  oldCountryCode: CountriesKorEngNameDialISOAlpha2;
  /** 변경 후 휴대폰번호 */
  newPhone: string;
  /** 변경 후 휴대폰번호 국가 코드 */
  newCountryCode: CountriesKorEngNameDialISOAlpha2;
  /** 휴대폰번호 변경 관련 승인 상태 */
  status: string;
  /** 승인 요청 타입 */
  type: string;
  /** 생성일시 */
  createdAt: string;
  /** 수정일시 */
  updatedAt: string;
  /** 휴대폰번호 변경 요청한 사용자 userID (일렉트론 유저) */
  requestorID: string;
  /** 휴대폰번호 변경 요청을 승인 또는 거절한자 userID (모바일 앱 유저) */
  responderID?: string;
  /** 승인 또는 미승인일시 */
  respondedAt?: string;
}

export interface CountriesKorEngNameDialISOAlpha2 {
  /** 국가 정보 ObjectId */
  id: string;
  /** 국가 한국어 이름 */
  koreanCountryName: string;
  /** 국가 영어 이름 */
  englishCountryName: string;
  /** 국가 전화번호 코드 */
  internationalDialingCodes: string;
  /** 국가 코드 ISO Alpha 2 */
  countryCodeISOAlpha2: string;
}

export interface ApprovalMobilePhoneChangeCountryCodeHospitalName {
  /** 휴대폰번호 변경 요청 ID */
  _id: string;
  /** 병원 ID */
  hospitalID: HospitalShortName;
  /** 휴대폰번호 변경 요청한 모바일 앱 유저의 userID */
  userID: string;
  /** 휴대폰번호 변경 요청한 모바일 앱 유저의 서비스 ID */
  hserviceID: string;
  /** 변경 전 휴대폰번호 */
  oldPhone: string;
  /** 변경 전 휴대폰번호 국가 코드 */
  oldCountryCode: CountriesKorEngNameDialISOAlpha2;
  /** 변경 후 휴대폰번호 */
  newPhone: string;
  /** 변경 후 휴대폰번호 국가 코드 */
  newCountryCode: CountriesKorEngNameDialISOAlpha2;
  /** 휴대폰번호 변경 관련 승인 상태 */
  status: string;
  /** 승인 요청 타입 */
  type: string;
  /** 생성일시 */
  createdAt: string;
  /** 수정일시 */
  updatedAt: string;
  /** 휴대폰번호 변경 요청한 사용자 userID (일렉트론 유저) */
  requestorID: string;
  /** 휴대폰번호 변경 요청을 승인 또는 거절한자 userID (모바일 앱 유저) */
  responderID?: string;
  /** 승인 또는 미승인일시 */
  respondedAt?: string;
}

export interface HospitalShortName {
  /** 병원 ID */
  _id: string;
  /** 사용자에게 보여질 병원명 */
  shortName?: string;
}

export interface ApprovalChatroomControllerFindResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  /** 채팅방 참여 요청 목록. 없으면 빈 배열 */
  data: {
    /** 승인 요청 ID */
    _id: string;
    /** 병원 ID */
    hospitalID: string;
    /** 참여를 요청한 직원 */
    requestorID:
      | string
      | {
          /** 유저 ID */
          _id: string;
          /** 닉네임 */
          name?: string;
          /** 실명 */
          realName?: string;
          /** 유저 타입 */
          type?: number;
          /** 직무 */
          jobType?: string;
        };
    /** 참여를 요청한 채팅방 ID */
    chatRoomID: string;
    /** 참여를 요청한 채팅방의 이름(환자 채팅방이면 환자 이름) */
    chatRoomName: string;
    /** 승인 상태. waiting / approved / rejected */
    status: string;
    /** 승인 요청 타입. join / mobilePhoneChange */
    type: string;
    /** 생성 일시 */
    createdAt: string;
    /** 마지막 수정 일시 */
    updatedAt: string;
    /** 승인·거절한 직원. 대기중 요청은 키 자체가 없다 */
    responderID?:
      | string
      | {
          /** 유저 ID */
          _id: string;
          /** 닉네임 */
          name?: string;
          /** 실명 */
          realName?: string;
          /** 유저 타입 */
          type?: number;
          /** 직무 */
          jobType?: string;
        };
    /** 승인·거절 일시. 대기중 요청은 키 자체가 없다 */
    respondedAt?: string;
    /** mongoose 버전 키. 문서 이력에 따라 없을 수 있다 */
    __v?: number;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ApiApprovalChatroomElFindParams {
  /** (required) 채팅방 ID */
  chatRoomID: string;
  /**
   * (optional) 승인 상태. 기본값 대기중인 승인 조회. 빈 값으로 전송 시 기본값 waiting
   * @default "waiting"
   */
  status?: string;
  /**
   * (optional) 승인 요청 타입. 기본값 채팅방 입장
   * @default "join"
   */
  type?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** key option */
  key?: string;
  /** way option */
  way?: number;
}

export type ApiApprovalChatroomElFindData = ApiResponse & {
  data: ApprovalChatRoomUserInfo[];
};

export type ApiApprovalChatroomElCreateData = ApiResponse & {
  data: ApprovalChatRoomUserInfo;
};

export type ApiApprovalChatroomElUpdateData = ApiResponse & {
  data: ApprovalChatRoomUserInfo;
};

export interface ApiApprovalChatroomHmFindParams {
  /** (required) 채팅방 ID */
  chatRoomID: string;
  /**
   * (optional) 승인 상태. 기본값 대기중인 승인 조회. 빈 값으로 전송 시 기본값 waiting
   * @default "waiting"
   */
  status?: string;
  /**
   * (optional) 승인 요청 타입. 기본값 채팅방 입장
   * @default "join"
   */
  type?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** key option */
  key?: string;
  /** way option */
  way?: number;
}

export type ApiApprovalChatroomHmFindData = ApiResponse & {
  data: ApprovalChatRoomUserInfo[];
};

export type ApiApprovalChatroomHmUpdateData = ApiResponse & {
  data: ApprovalChatRoomUserInfo;
};

export interface ApiApprovalMobilephonechangeElFindOneParams {
  /** (required) 서비스 ID */
  hserviceID: string;
  /**
   * (optional) 승인 상태. 기본값 대기중인 승인 조회. 빈 값으로 전송 시 기본값 waiting
   * @default "waiting"
   */
  status?: string;
  /**
   * (optional) 승인 요청 타입. 기본값 전화번호 변경
   * @default "mobilePhoneChange"
   */
  type?: string;
}

export type ApiApprovalMobilephonechangeElFindOneData = ApiResponse & {
  data: ApprovalMobilePhoneChangeCountryCode;
};

export type ApiApprovalMobilephonechangeElUpdateData = ApiResponse & {
  data: ApprovalMobilePhoneChangeCountryCode;
};

export interface ApiApprovalMobilephonechangeMFindOneParams {
  /** (required) 유저 ID */
  userID: string;
  /**
   * (optional) 승인 상태. 기본값 대기중인 승인 조회. 빈 값으로 전송 시 기본값 waiting
   * @default "waiting"
   */
  status?: string;
  /**
   * (optional) 승인 요청 타입. 기본값 전화번호 변경
   * @default "mobilePhoneChange"
   */
  type?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** key option */
  key?: string;
  /** way option */
  way?: number;
}

export type ApiApprovalMobilephonechangeMFindOneData = ApiResponse & {
  data: ApprovalMobilePhoneChangeCountryCodeHospitalName;
};

export type ApiApprovalMobilephonechangeMUpdateData = ApiResponse & {
  data: ApprovalMobilePhoneChangeCountryCode;
};

export interface ApprovalChatroomControllerFindParams {
  /**
   * 채팅방 ID
   * @example "6732be1387ee3809f9d76383"
   */
  chatRoomID: string;
  /**
   * 승인 상태. 주지 않거나 빈 값이면 waiting(대기중)만 조회한다
   * @example "waiting"
   */
  status?: string;
  /**
   * 승인 요청 타입. **기본값이 없다** — 주지 않으면 타입으로 거르지 않는다
   * @example "join"
   */
  type?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수. 0 이면 제한 없음 */
  limit?: number;
  /** 정렬하고자 하는 field. 주지 않으면 존재하지 않는 필드로 정렬해 생성 순서가 유지된다 */
  key?: string;
  /** 정렬 방향. 1 오름차순, -1 내림차순. 미지정은 -1 */
  way?: number;
}

export type ApprovalChatroomControllerFindData = ApprovalChatroomControllerFindResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * No description
     *
     * @tags V3-approval_ChatRoom
     * @name ApiApprovalChatroomElFind
     * @summary 채팅방 관련 동작 승인 요청 조회 (GET /v3/api/approval/chatroom/find 로 대체됨)
     * @request GET:/v3/api/approval/chatroom/el/find
     * @deprecated
     * @secure
     * @response `200` `ApiApprovalChatroomElFindData` \[\{approval_ChatRoom\}\] 선택한 chatRoomID 대한 approval_ChatRoom 컬렉션 객체 배열
     */
    apiApprovalChatroomElFind: (query: ApiApprovalChatroomElFindParams, params: RequestParams = {}) =>
      this.request<ApiApprovalChatroomElFindData, any>({
        path: `/v3/api/approval/chatroom/el/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-approval_ChatRoom
     * @name ApiApprovalChatroomElCreate
     * @summary 채팅방 관련 동작 승인 요청 생성
     * @request POST:/v3/api/approval/chatroom/el/create
     * @secure
     * @response `200` `ApiApprovalChatroomElCreateData` \{approval_ChatRoom\} 생성된 approval_ChatRoom 컬렉션 객체
     */
    apiApprovalChatroomElCreate: (
      data: {
        /** (required) 병원 ID */
        hospitalID: string;
        /** (required) 승인 요청하려는 채팅방 ID */
        chatRoomID: string;
        /**
         * (required) 승인 요청하려는 동작. 기본값 join(참여)
         * @default "join"
         */
        type: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiApprovalChatroomElCreateData, any>({
        path: `/v3/api/approval/chatroom/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-approval_ChatRoom
     * @name ApiApprovalChatroomElUpdate
     * @summary 채팅방 관련 동작 승인 요청 수정
     * @request POST:/v3/api/approval/chatroom/el/update
     * @secure
     * @response `200` `ApiApprovalChatroomElUpdateData` \{approval_ChatRoom\} 수정된 approval_ChatRoom 컬렉션 객체
     */
    apiApprovalChatroomElUpdate: (
      data: {
        /** (required) 승인 또는 미승인하려는 채팅방 승인 ID */
        approvalChatRoomID: string;
        /** (required) 승인 여부. 승인 시 true, 미승인 시 false */
        isApproved: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiApprovalChatroomElUpdateData, any>({
        path: `/v3/api/approval/chatroom/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-approval_ChatRoom
     * @name ApiApprovalChatroomHmFind
     * @summary 병원 상담 모바일 앱 - 채팅방 관련 동작 승인 요청 조회 (GET /v3/api/approval/chatroom/find 로 대체됨)
     * @request GET:/v3/api/approval/chatroom/hm/find
     * @deprecated
     * @secure
     * @response `200` `ApiApprovalChatroomHmFindData` \[\{approval_ChatRoom\}\] 선택한 chatRoomID 대한 approval_ChatRoom 컬렉션 객체 배열
     */
    apiApprovalChatroomHmFind: (query: ApiApprovalChatroomHmFindParams, params: RequestParams = {}) =>
      this.request<ApiApprovalChatroomHmFindData, any>({
        path: `/v3/api/approval/chatroom/hm/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-approval_ChatRoom
     * @name ApiApprovalChatroomHmUpdate
     * @summary 병원 상담 모바일 앱 - 채팅방 관련 동작 승인 요청 수정
     * @request POST:/v3/api/approval/chatroom/hm/update
     * @secure
     * @response `200` `ApiApprovalChatroomHmUpdateData` \{approval_ChatRoom\} 수정된 approval_ChatRoom 컬렉션 객체
     */
    apiApprovalChatroomHmUpdate: (
      data: {
        /** (required) 승인 또는 미승인하려는 채팅방 승인 ID */
        approvalChatRoomID: string;
        /** (required) 승인 여부. 승인 시 true, 미승인 시 false */
        isApproved: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiApprovalChatroomHmUpdateData, any>({
        path: `/v3/api/approval/chatroom/hm/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-approval_MobilePhoneChange
     * @name ApiApprovalMobilephonechangeElFindOne
     * @summary 전화번호 변경 요청 동작 승인 요청 단일 조회
     * @request GET:/v3/api/approval/mobilephonechange/el/find/one
     * @secure
     * @response `200` `ApiApprovalMobilephonechangeElFindOneData` \[\{approval_MobilePhoneChange\}\] 선택한 userID 대한 approval_MobilePhoneChange 컬렉션 객체 배열
     */
    apiApprovalMobilephonechangeElFindOne: (
      query: ApiApprovalMobilephonechangeElFindOneParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiApprovalMobilephonechangeElFindOneData, any>({
        path: `/v3/api/approval/mobilephonechange/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-approval_MobilePhoneChange
     * @name ApiApprovalMobilephonechangeElUpdate
     * @summary 전화번호 변경 요청 동작 승인 요청 수정. 일렉트론에서는 항상 취소만 가능
     * @request POST:/v3/api/approval/mobilephonechange/el/update
     * @secure
     * @response `200` `ApiApprovalMobilephonechangeElUpdateData` \{approval_MobilePhoneChange\} 수정된 approval_MobilePhoneChange 컬렉션 객체
     */
    apiApprovalMobilephonechangeElUpdate: (
      data: {
        /** (required) 취소하려는 전화번호 변경 요청 승인 ID */
        approvalMobilePhoneChangeID: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiApprovalMobilephonechangeElUpdateData, any>({
        path: `/v3/api/approval/mobilephonechange/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-approval_MobilePhoneChange
     * @name ApiApprovalMobilephonechangeMFindOne
     * @summary 모바일 - 전화번호 변경 요청 동작 승인 요청 단일 조회
     * @request GET:/v3/api/approval/mobilephonechange/m/find/one
     * @secure
     * @response `200` `ApiApprovalMobilephonechangeMFindOneData` \[\{approval_MobilePhoneChange\}\] 선택한 userID 대한 approval_MobilePhoneChange 컬렉션 객체 배열
     */
    apiApprovalMobilephonechangeMFindOne: (
      query: ApiApprovalMobilephonechangeMFindOneParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiApprovalMobilephonechangeMFindOneData, any>({
        path: `/v3/api/approval/mobilephonechange/m/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-approval_MobilePhoneChange
     * @name ApiApprovalMobilephonechangeMUpdate
     * @summary 모바일 - 전화번호 변경 요청 동작 승인 요청 수정
     * @request POST:/v3/api/approval/mobilephonechange/m/update
     * @secure
     * @response `200` `ApiApprovalMobilephonechangeMUpdateData` \{approval_MobilePhoneChange\} 수정된 approval_MobilePhoneChange 컬렉션 객체
     */
    apiApprovalMobilephonechangeMUpdate: (
      data: {
        /** (required) 승인 또는 미승인하려는 전화번호 변경 요청 승인 ID */
        approvalMobilePhoneChangeID: string;
        /** (required) 승인 여부. 승인 시 true, 미승인 시 false */
        isApproved: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiApprovalMobilephonechangeMUpdateData, any>({
        path: `/v3/api/approval/mobilephonechange/m/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description chatRoomID 로 채팅방 참여 요청 목록을 조회한다. status 를 주지 않으면 대기중(waiting)인 요청만 돌려준다. type 은 기본값이 없어 주지 않으면 타입으로 거르지 않는다. 요청자·응답자는 유저 정보 객체로 채워서 돌려준다.
     *
     * @tags V3-approval_ChatRoom
     * @name ApprovalChatroomControllerFind
     * @summary 채팅방 관련 동작 승인 요청 조회
     * @request GET:/v3/api/approval/chatroom/find
     * @secure
     * @response `200` `ApprovalChatroomControllerFindData` success
     */
    approvalChatroomControllerFind: (query: ApprovalChatroomControllerFindParams, params: RequestParams = {}) =>
      this.request<ApprovalChatroomControllerFindData, any>({
        path: `/v3/api/approval/chatroom/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
